import Model from '../orm/Model'

export default class Task extends Model {

    static entity = 'tasks'

    static fields() {
        return {
            id: this.attr(null),
            description: this.attr(''),
            taskable_id: this.number(),
            taskable_type: this.string(),
            taskable: this.morphTo('taskable_id', 'taskable_type'),
            created_at: this.attr(null),
            deleted_at: this.attr(null)
        }
    }

    static graphql = {
        all: {
            parameters: {}
        },
        close: {
            type: 'closeTask',
            parameters: {
                id: 'Int!'
            }
        }
    }
}